module.exports = {
      id: "right-arrow-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }